
import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classes from "./LowBalancePage.module.css";

const LowBalancePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <main className={classes.page}>
      <div className={classes.glowOne} />
      <div className={classes.glowTwo} />

      <motion.div
        className={classes.overlay}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.25 }}
      >
        <motion.section
          className={classes.modal}
          role="dialog"
          aria-modal="true"
          aria-labelledby="low-balance-title"
          initial={{ opacity: 0, y: 25, scale: 0.94 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
        >
          <div className={classes.iconWrap}>
            <span className={classes.warningIcon}>!</span>
          </div>

<p className={classes.eyebrow}>{t("123")}</p>

<h1 id="low-balance-title" className={classes.title}>
  {t("124")}
</h1>

<p className={classes.description}>{t("125")}</p>

<div className={classes.info}>
  <span className={classes.infoDot} />
  <span>{t("126")}</span>
</div>

<button
  type="button"
  className={classes.primaryButton}
  onClick={() => navigate("/login", { replace: true })}
>
  {t("127")}
</button>

<button
  type="button"
  className={classes.secondaryButton}
  onClick={() => navigate(-1)}
>
  {t("128")}
</button>

<p className={classes.footer}>{t("129")}</p>
        </motion.section>
      </motion.div>
    </main>
  );
};

export default LowBalancePage;
